import { z } from '@harvestiq/zod';
import { dbCampaignRecipientsSchema } from './db-campaign-recipients';

const campaignRecipientUserSchema = dbCampaignRecipientsSchema
  .pick({
    userId: true,
  })
  .extend({
    email: z.string().email(),
    name: z.string(),
    agentName: z.string().optional(),
    agentEmail: z.string().email().optional(),
  });
export type CampaignRecipientUser = z.infer<typeof campaignRecipientUserSchema>;
